/*
 * Display helpers that never turn missing data into a number.
 * A value that is null/undefined/''/NaN renders as an em dash, never "0".
 */
export const DASH = '—';

export function isNum(v) {
    return v !== null && v !== undefined && v !== '' && Number.isFinite(Number(v));
}

export function rupees(v, { signed = false } = {}) {
    if (!isNum(v)) return DASH;
    const n = Number(v);
    const s = '₹' + Math.abs(n).toLocaleString('en-IN', { maximumFractionDigits: 2 });
    return n < 0 ? '-' + s : (signed && n > 0 ? '+' + s : s);
}

export function times(v, digits = 2) {
    return isNum(v) ? Number(v).toFixed(digits) + 'x' : DASH;
}

export function percent(v, digits = 1) {
    return isNum(v) ? Number(v).toFixed(digits) + '%' : DASH;
}

/** A count from an API payload: dash while loading or after an error, never a fake 0. */
export function count(v, state = { loaded: true, error: false }) {
    if (state.error || !state.loaded) return DASH;
    return isNum(v) ? Number(v).toLocaleString('en-IN') : DASH;
}

export function crore(v) {
    if (!isNum(v) || Number(v) <= 0) return DASH;
    return '₹' + Number(v).toLocaleString('en-IN', { maximumFractionDigits: 0 }) + ' Cr';
}

/** GMP as % of the upper price band, or null when either side is missing. */
export function gmpPercent(gmp, priceMax) {
    if (!isNum(gmp) || !isNum(priceMax) || Number(priceMax) === 0) return null;
    return (Number(gmp) / Number(priceMax)) * 100;
}

/**
 * Mirrors IpoFacts::subscriptionConsistent(): an overall multiple must lie
 * between the lowest and highest category multiples. Rows that fail this
 * (a known upstream data problem) show only the overall figure.
 */
export function subscriptionConsistent(sub) {
    if (!sub || !isNum(sub.total)) return false;
    const cats = [sub.retail, sub.nii, sub.qib, sub.employee].filter(isNum).map(Number);
    if (cats.length < 2) return false;
    const t = Number(sub.total);
    return t <= Math.max(...cats) * 1.01 + 0.01 && t >= Math.min(...cats) * 0.99 - 0.01;
}
